import { Box, Divider, Group, Text, useMantineColorScheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

import classes from "./Bar.module.css";

import type { FC } from "react";

export type PerformanceBarProps = {
  align?: "left" | "right";
  label: string;
  value: number;
  logarithmicValue?: number;
};

const BAR_MAX_WIDTH_DESKTOP = 140;
const BAR_MAX_WIDTH_MOBILE = 40;

export const PerformanceBar: FC<PerformanceBarProps> = ({
  align = "right",
  label,
  value,
  logarithmicValue,
}) => {
  const isMobile = useMediaQuery("(max-width: 549px)");
  const { colorScheme } = useMantineColorScheme();
  const barAlign = align === "right" ? "flex-end" : "flex-start";
  const barStyle =
    align === "right"
      ? {
          borderTopLeftRadius: "var(--mantine-radius-xs)",
          borderBottomLeftRadius: "var(--mantine-radius-xs)",
        }
      : {
          borderTopRightRadius: "var(--mantine-radius-xs)",
          borderBottomRightRadius: "var(--mantine-radius-xs)",
        };

  const isDark = colorScheme === "dark";
  const colorVariant = value >= 0 ? "success" : "danger";

  const barHeight = isMobile ? 25 : 30;
  const barMaxWidth = isMobile ? BAR_MAX_WIDTH_MOBILE : BAR_MAX_WIDTH_DESKTOP;

  const fontSize = { base: "xs", sm: "sm" };

  return (
    <Group align="center" justify={barAlign} wrap="nowrap">
      {align === "right" && (
        <Text c={colorVariant} fz={fontSize}>
          {label}
        </Text>
      )}
      <Group gap={0} align="center" wrap="nowrap">
        {align === "left" && <Divider orientation="vertical" h={38} size="sm" />}
        <Box
          bg={`primary.${isDark ? 4 : 1}`}
          className={classes.bar_performanceItem}
          w={2 + (logarithmicValue ?? value) * (barMaxWidth - 2)}
          maw={barMaxWidth}
          h={barHeight}
          style={barStyle}
        />
        {align === "right" && <Divider orientation="vertical" h={38} size="sm" />}
      </Group>
      {align === "left" && (
        <Text c={colorVariant} fz={fontSize}>
          {label}
        </Text>
      )}
    </Group>
  );
};
